export default function footerLinks(widgetNameVariable, widgetOptsVariable, widgetTitle) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;

  const wrapContainerClass = `${widgetName}-container-wrapper`;

  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  if (widgetTitle) {
    $widget.before(`<h3>${widgetTitle}</h3>`);
  }

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: 'all',
    showDescription: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: true,
    moreButton: false,
    maxItemsVisible: 5,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    const noneHasUrl = widgetData.every((link) => !link.URL);

    if (noneHasUrl) {
      $(`.${wrapContainerClass}`).addClass('empty-links');
    }

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);

      $cardItem.find('.card-content').remove();
      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
          </div>`);

      if (!URL) {
        $cardItem.remove();
      }
    });
  }
}
